import React from 'react';
import { ShieldCheckIcon, ServerIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const pillars = [
  {
    Icon: ShieldCheckIcon,
    titleKey: 'longevity.inox.title',
    defaultTitle: 'Индустриски Inox 304',
    textKey: 'longevity.inox.text',
    defaultText: "Отпорен на дожд, снег и екстремни температури. Не 'рѓосува и не бледнее.",
  },
  {
    Icon: ServerIcon,
    titleKey: 'longevity.servers.title',
    defaultTitle: 'Безбедни Сервери',
    textKey: 'longevity.servers.text',
    defaultText:
      'Податоците се чуваат на сигурни cloud сервери со редовни бекапи. Вашите спомени се безбедни.',
  },
  {
    Icon: CheckCircleIcon,
    titleKey: 'longevity.nohidden.title',
    defaultTitle: 'Нема Скриени Трошоци',
    textKey: 'longevity.nohidden.text',
    defaultText:
      '1.990 денари е конечната цена за плочката, серверот и одржувањето. Нема месечни претплати.',
  },
];

const LongevitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-50 py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 tracking-tight">
            {t('longevity.title', 'Гаранција за Трајност')}
          </h2>
          <div className="mt-3 mx-auto w-12 h-0.5 bg-gray-300 rounded-full" />
        </div>

        {/* 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map(({ Icon, titleKey, defaultTitle, textKey, defaultText }) => (
            <div
              key={titleKey}
              className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col items-start gap-4"
            >
              <div className="flex items-center justify-center w-11 h-11 rounded-full bg-gray-100 shrink-0">
                <Icon className="w-6 h-6 text-gray-600" aria-hidden="true" />
              </div>
              <h3 className="text-base font-semibold text-gray-800">
                {t(titleKey, defaultTitle)}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {t(textKey, defaultText)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LongevitySection;
